import styled from "styled-components";

interface IFlexFragment {
	breakpoint?: number;
}

export const FlexColumn = styled.div`
    display: flex;
    flexDirection: column;
    justifyContent: flex-start;
`;



// WEBPACK FOOTER //
// ./src/panels/checkout/components/CustomStyles.tsx